<section class="responsible-gaming-screen tw-w-full" data-cy="responsible-gaming-screen">
  <!-- Heading bar: title separated from the content card (mirrors Help). -->
  <header
    class="
      heading-section
      tw-flex
      tw-h-[58.5px]
      tw-items-center
      tw-justify-between
      tw-bg-[#F0F0F0]
      tw-rounded-[12px]
      tw-p-[10px_18px]
      tw-mb-[16px]
    "
    data-cy="responsible-gaming-header"
  >
    <h3
      class="tw-font-bold tw-text-[18px] tw-text-[#000000] tw-tracking-[0.5px] tw-m-0"
      data-cy="responsible-gaming-title"
    >
      {{ 'account.responsible.gaming' | translate: 'Responsible Gaming' }}
    </h3>
    <button
      type="button"
      (click)="close()"
      class="
        responsible-gaming-close
        tw-flex
        tw-items-center
        tw-justify-center
        tw-bg-transparent
        tw-border-0
        tw-cursor-pointer
      "
      attr.aria-label="{{ 'ui.account.close.responsible.gaming' | translate: 'Close responsible gaming' }}"
      data-cy="responsible-gaming-close"
    >
      <mat-icon class="!tw-text-[22px] tw-text-[#000000]">close</mat-icon>
    </button>
  </header>

  <!-- Content card -->
  <div class="responsible-gaming-panel tw-rounded-[12px] tw-p-[18px]" data-cy="responsible-gaming-panel">
    <form
      [formGroup]="responsibleGamingForm"
      id="responsibleGamingForm"
      class="responsible-gaming-form-page"
    >
      <!-- Intro / timeout explanation -->
      <div class="timeout-exclusion-section tw-text-center tw-text-[14px] tw-text-[#5D5D5D]">
        <p class="tw-mb-[5px]" data-cy="resp-txt-1">
          {{ 'account.responsible.gaming.self.excl.para1' | translate }}
          {{ 'account.responsible.gaming.self.excl.para2' | translate }}
        </p>

        <p class="tw-mb-[14px]" data-cy="resp-timeout-txt">
          <span class="tw-font-bold tw-text-[17px] tw-text-[#0F2950]">
            {{ 'account.responsible.gaming.timeout.excl' | translate }}
          </span> <br>
          {{ 'account.responsible.gaming.self.excl.para3' | translate }}
          {{ 'account.responsible.gaming.self.excl.para4' | translate }}
        </p>
      </div>

      <!-- Timeout / self-exclude type selectors -->
      <div class="timeout-self-exclude-section tw-flex tw-text-[16px] tw-text-[#000000] tw-mb-[15px]">
        <button
          type="button"
          (click)="responsibleTypeIs('timeout')"
          class="
            tw-flex tw-items-center tw-bg-[#E4ECF7] tw-rounded-[5px]
            tw-border-[1px] tw-border-[#2F7EE8] tw-mr-[7.5px]
          "
          [class.active]="responsibleType === 'timeout'"
          data-cy="resp-timeout-btn"
        >
          <img
            class="l-mode tw-mr-[15px]"
            src="/assets/images/profile/responsible_gaming/timeout_icon_light.svg"
            alt="{{ 'ui.account.timeout.icon' | translate: 'timeout icon' }}"
          >
          <img
            class="d-mode tw-mr-[15px]"
            src="/assets/images/profile/responsible_gaming/timeout_icon_dark.svg"
            alt="{{ 'ui.account.timeout.icon' | translate: 'timeout icon' }}"
          >
          <span>
            {{ 'account.responsible.gaming.timeout' | translate: 'Timeout' }} <br>
            {{ 'ui.account.timeout.day.range' | translate: '3-365 Days' }}
          </span>
        </button>
        <button
          type="button"
          (click)="responsibleTypeIs('self-exclude')"
          class="
            tw-flex tw-items-center tw-bg-[#E4ECF7] tw-rounded-[5px]
            tw-border-[1px] tw-border-[#2F7EE8] tw-ml-[7.5px]
          "
          [class.active]="responsibleType === 'self-exclude'"
          data-cy="resp-self-btn"
        >
          <img
            class="l-mode tw-mr-[12px]"
            src="/assets/images/profile/responsible_gaming/self_exclude_icon_light.svg"
            alt="{{ 'ui.account.self.exclude.icon' | translate: 'self exclude icon' }}"
          >
          <img
            class="d-mode tw-mr-[12px]"
            src="/assets/images/profile/responsible_gaming/self_exclude_icon_dark.svg"
            alt="{{ 'ui.account.self.exclude.icon' | translate: 'self exclude icon' }}"
          >
          <span>
            {{ 'account.responsible.gaming.self.excl' | translate: 'Self-Exclude' }} <br>
            {{ 'ui.account.self.exclude.year.range' | translate: '1-5 Years' }}
          </span>
        </button>
      </div>

      <!-- What the selected option means -->
      <div class="what-timeout-means-section">
        <p
          class="tw-text-center tw-font-bold tw-text-[17px] tw-text-[#0F2950]"
          data-cy="resp-options-meaning"
        >
          {{
            responsibleType === 'self-exclude'
              ? ('account.responsible.gaming.self.excl.heading3' | translate: 'What a Self-exclusion means:')
              : ('account.responsible.gaming.timeout.heading' | translate: 'What a Timeout means:')
          }}
        </p>
        <ul>
          <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-1">
            {{ 'account.responsible.gaming.timeout.mean1' | translate: 'You can\'t log into your account.' }}
          </li>
          <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-2">
            {{
              responsibleType === 'self-exclude'
                ? ('account.responsible.gaming.self.excl.mean1' | translate: 'You\'ll need to contact Support to reactivate after exclusion period')
                : ('ui.account.timeout.reactivate.note' | translate: 'Your account will reactivate automatically at the end of your Timeout.')
            }}
          </li>
          <li class="tw-relative tw-text-[14px] tw-text-[#5D5D5D]" data-cy="resp-bullet-3">
            {{ 'account.responsible.gaming.timeout.mean3' | translate: 'You won\'t receive any marketing communications.' }}
          </li>
        </ul>
      </div>

      <!-- Validation messages -->
      <div>
        <span
          class="tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['days'] && formVal['days'].errors
            && (formVal['days'].touched || formVal['days'].dirty)"
          data-cy="resp-timeout-error"
        >
          {{
            formVal['days'].errors['min']
              ? ('ui.account.timeout.min.days' | translate: 'Minimum timeout day is 3 days.')
              : formVal['days'].errors['max']
                ? ('ui.account.timeout.max.days' | translate: 'Maximum timeout day is 365 days.')
                : ('ui.account.please.enter.days' | translate: 'Please enter Number of Days.')
          }}
        </span>

        <span
          class="tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['selfExclude'] && formVal['selfExclude'].errors
            && (formVal['selfExclude'].touched || formVal['selfExclude'].dirty)"
        >
          {{ 'account.responsible.gaming.self.excl.input.error' | translate: 'Please select Self-Exclude Length.' }}
        </span>
      </div>

      <!-- Days input / years dropdown + submit -->
      <div class="enter-number-of-days-section tw-mb-[18px]">
        <div class="tw-flex">
          <input
            *ngIf="responsibleType === 'timeout'"
            formControlName="days"
            class="
              days
              tw-w-[50%]
              tw-h-[38px]
              tw-bg-[#EAEAEA]
              tw-rounded-[4px]
              tw-border-[1px]
              tw-border-[#959595]
              tw-mr-[6px]
              tw-px-[10px]
            "
            type="number"
            placeholder="{{ 'ui.account.enter.number.of.days' | translate: 'Enter number of Days' }}"
            (keyup.enter)="responsibleGamingForm.valid ? doresponsibleGamingForm() : null"
            data-cy="resp-timeout-input"
          >

          <select
            *ngIf="responsibleType === 'self-exclude'"
            formControlName="selfExclude"
            class="
              years
              tw-w-[50%]
              tw-h-[38px]
              tw-bg-[#EAEAEA]
              tw-rounded-[4px]
              tw-border-[1px]
              tw-border-[#959595]
              tw-mr-[5px]
              tw-px-[10px]
            "
            data-cy="resp-self-dropdown"
          >
            <option value="" disabled>{{ 'ui.account.select.length' | translate: 'Select length' }}</option>
            <option value="1">{{ 'ui.account.1.year' | translate: '1 Year' }}</option>
            <option value="3">{{ 'ui.account.3.years' | translate: '3 Years' }}</option>
            <option value="5">{{ 'ui.account.5.years' | translate: '5 Years' }}</option>
            <option value="999">{{ 'account.responsible.gaming.self.excl.lifetime' | translate: 'Lifetime' }}</option>
          </select>

          <button
            type="button"
            (click)="doresponsibleGamingForm()"
            class="
              submit-request
              tw-relative
              tw-flex
              tw-items-center
              tw-justify-center
              tw-w-[50%]
              tw-h-[38px]
              tw-bg-[#3080EC]
              tw-rounded-[4px]
              tw-capitalize
              tw-text-[16px]
              tw-text-[#FFFFFF]
              tw-ml-[6px]
            "
            [disabled]="isProccesing"
            data-cy="resp-submit-btn"
          >
            {{ 'account.responsible.gaming.submitrequest' | translate: 'submit request' }}
            <mat-icon class="!tw-text-[20px] tw-ml-[4px]">arrow_forward</mat-icon>
          </button>
        </div>

        <!-- API response message -->
        <div class="tw-pt-[5px] tw-text-center">
          <span
            *ngIf="responsibleGamingForm.errors"
            class="error-msg tw-text-xs tw-text-[#D83A19]"
          >
            {{ responsibleGamingForm.errors['apiResponse'] }}
          </span>
        </div>
      </div>

      <!-- Help resources -->
      <div class="qr-section tw-text-center tw-text-[14px] tw-text-[#5D5D5D]">
        <p class="tw-mb-[15px]" data-cy="resp-txt-2">
          {{ 'ui.account.gambling.problem.note' | translate }} <br>
          <span class="tw-text-[#3080EC]" data-cy="resp-txt-3">
            {{ 'ui.account.please.call.gambler' | translate: 'Please call: 1-800-GAMBLER' }}
          </span>
        </p>
        <p class="tw-text-[14px] tw-text-[#5D5D5D] tw-mb-[15px]" data-cy="resp-txt-4">
          {{ 'account.responsible.gaming.para2.note' | translate: 'New York Residents:' }}
          {{ 'account.responsible.gaming.para2' | translate }} <br>
          <a
            href="https://www.gaming.ny.gov/pdf/UpdatedSEForm-091020.pdf"
            target="_blank"
            class="tw-text-[13px] tw-text-[#3080EC]"
            data-cy="resp-link-1"
          >
            https://www.gaming.ny.gov/pdf/UpdatedSEForm-091020.pdf
          </a>
        </p>

        <p class="tw-text-[14px] tw-text-[#5D5D5D] tw-mt-[15px] tw-mb-[10px]" data-cy="resp-txt-5">
          <span class="scan-here tw-font-bold tw-text-[#0F2950]" data-cy="resp-scan-here">
            {{ 'ui.account.need.help' | translate: 'Need help?' }}
          </span>
          {{ 'ui.account.talk.to.someone.about.your.gambling' | translate: 'Talk to someone about your gambling. For help with a gambling problem call 1-877-8HOPE-NY or Text HOPENY (467369). Standard rates may apply.' }} <br>
          <a
            href="https://nyproblemgamblinghelp.org"
            target="_blank"
            class="tw-text-[#3080EC]"
            data-cy="resp-link-2"
          >
            https://nyproblemgamblinghelp.org
          </a>
        </p>
      </div>
    </form>
  </div>
</section>
